





















































































































import { AgentModuleConfiguration, ClientAgent } from "@/models";
import { Component, Prop, Vue } from "vue-property-decorator";
import MultipleProduct from "@/models/Agents/MultipleProduct";
import ClientProductWithHierarchy from "@/models/Agents/ProductWithHierarchy";
import { differentValues } from "@/utils/tableDifferencesVisualizer";

@Component({})
export default class MatchMultipleProductPrincipalAccordionTable extends Vue {
  @Prop() readonly entities!: MultipleProduct[];
  @Prop() readonly agentModuleConfiguration!: AgentModuleConfiguration;

  getPrincipaProductlId(entity: MultipleProduct): string | number {
    return entity.principalProductId ?? "";
  }

  getPrincipalCompanyId(entity: MultipleProduct): string | number {
    return entity.principalCompanyId ?? "";
  }

  getAgentCompanyName(entity: MultipleProduct): string {
    return entity.agentCompany?.name ?? "";
  }

  getAgencyId(entity: MultipleProduct): string {
    return entity.currentAgency?.id ?? "";
  }

  getAgencyName(entity: MultipleProduct): string {
    return entity.currentAgency?.name ?? "";
  }

  getAgentCompanyAgentByType(
    agentType: string,
    entity: MultipleProduct
  ): ClientAgent | null {
    return (
      entity.currentAgentCompanyAgentAssociations?.find(
        (agentAss) => agentAss.agentType === agentType
      )?.agent || null
    );
  }

  getAgentCompanyAgentIdByType(
    agentType: string,
    entity: MultipleProduct
  ): string | null {
    return this.getAgentCompanyAgentByType(agentType, entity)?.id || null;
  }

  getAgentCompanyAgentNameByType(
    agentType: string,
    entity: MultipleProduct
  ): string | null {
    return this.getAgentCompanyAgentByType(agentType, entity)?.name || null;
  }

  differentValuesStyle(
    entities: ClientProductWithHierarchy[],
    property: keyof ClientProductWithHierarchy | null = null,
    func: Function | null = null,
    agentType: string | null = null
  ): string {
    return differentValues(entities, property, func, agentType)
      ? "difference-warning-field"
      : "";
  }
}
